export default interface Notification {
  id: number;
  title: string;
  triggerDate: string;
  linkType: LinkType;
  linkId: number | string;
  beenSeen: boolean;
}

export enum LinkType {
  appointment = 'appointment',
  deal = 'deal',
  post = 'post',
  reminder = 'reminder',
  task = 'task',
  ticket = 'ticket',
  wall = 'wall',
  request = 'request',
}
